<template>
  <Header></Header>
  <div class="main-height">
    <section class="activated">
      <div class="container">
        <div class="inner-container">
          <div class="row">
            <div class="col-12">
              <h2 class="fw-bold">
                Payment in progress
              </h2>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-12">
              <div class="text-3 mt-2 text-justify">
                Your payment is in progress. Please wait.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <Footer></Footer>
</template>

<script>
import { defineComponent } from 'vue'
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"
import AuthService from "@/services/auth-service";
import UsersService from "@/services/users-service"
import LeagueService from "@/services/league-service"
export default defineComponent({
  name: "PaymentInProgress",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      interval: null,
      error: null,
      previousUserProfileValue: null
    }
  },
  methods: {
    setData: function () {
      if (localStorage.getItem('userProfile')) {
        this.previousUserProfileValue = JSON.parse(localStorage.getItem('userProfile'))
      }
    },

    getUserLatest: function () {
      UsersService.getUserLatest().then((newUserLatest) => {
        if (newUserLatest) {
          this.compareUserLatest(newUserLatest)
        }
      }).catch((error) => {
        this.error = 'Error: ' + error
      })
    },

    compareUserLatest: function (newUserLatest) {
     if (this.previousUserProfileValue.planUpdated !== newUserLatest.userPlans) {
        this.handlePlanChange()
      }
    },

    handlePlanChange: function ( ) {
      UsersService.getUserProfile().then(() => {
        const userProfile = localStorage.getItem('userProfile') ? JSON.parse(localStorage.getItem('userProfile')) : null
        // CASE 1:
        // previous userPlan does not exist, new one exists
        if (!this.previousUserProfileValue.planStatus && userProfile) {
          //this.previousUserProfileValue = newUserProfileValue
         if (userProfile && userProfile.planActive && userProfile.planStatus) {
            LeagueService.getLeagueList().then(() => {
              this.$router.push('/events')
            }).catch((error) => {
              this.error = 'Error: ' + error
            })
          } else if (userProfile && !userProfile.planActive && !userProfile.planStatus) {
            this.$router.push('/payment-fail')
          }
          return
        }

        // CASE 2:
        // previous userPlan exists, new one exists, created changed
        if (this.previousUserProfileValue.planCreated !== userProfile.planCreated) {
          //this.previousUserProfileValue = newUserProfileValue
          if (userProfile && userProfile.planActive && userProfile.planStatus) {
            if (localStorage.getItem("forwarded")) {
              const tempForwarded = localStorage.getItem("forwarded")
              localStorage.removeItem("forwarded")
              window.location.assign(tempForwarded)
              return
            }
            LeagueService.getLeagueList().then(() => {
              this.$router.push('/events')
            }).catch((error) => {
              this.error = 'Error: ' + error
            })
          } else {
            this.$router.push('/payment-fail')
          }
          return
        }

        // still update tracker so it does not repeat endlessly
        this.previousUserProfileValue = userProfile
      }).catch((error) => {
        this.error = 'Error: ' + error
      })
    }
  },

  beforeMount() {
    if ( localStorage.getItem('userProfile') == null ) {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    } else {
      this.setData()
      this.getUserLatest()
    }
  },

  mounted() {
    this.interval = setInterval(function () {
      this.getUserLatest()
    }.bind(this), 5000)
  },

  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
})
</script>

<style>
@import '../assets/style.css';
</style>